import { CREATE_TYPE, UPDATE_TYPE, DELETE_TYPE } from './constants';
import { CREATE_TYPE_SUCCESS, UPDATE_TYPE_SUCCESS, DELETE_TYPE_SUCCESS } from './constants';

export const createType = ( { quizLocalizationId } ) => ( { type: CREATE_TYPE, quizLocalizationId } );
export const createTypeSuccess = ( quiz ) => ( { type: CREATE_TYPE_SUCCESS, quiz } );

export const updateType = ( { typeId, images, selectedType, button, url_image, title, image_copyright, description } ) => ( {
    type: UPDATE_TYPE,
    typeId,
    images,
    selectedType,
    button,
    url_image,
    title,
    image_copyright,
    description
} );
export const updateTypeSuccess = ( quiz ) => ( { type: UPDATE_TYPE_SUCCESS, quiz } );

export const deleteType = ( { typeId } ) => ( { type: DELETE_TYPE, typeId } );
export const deleteTypeSuccess = ( quiz ) => ( { type: DELETE_TYPE_SUCCESS, quiz } );

//TODO: add SUCCESS